//Global Settings
export var distanceThreshold = 50.0